import { useEffect } from "react";

export function useKeyListener(handler: (event: Event) => void) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      handler(event);
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
    // Reload only if ref or handler changes
  }, [handler]);
}
